import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';

import { settingsModel } from '../../../models/service/settings.model';
import { controlModel } from '../../../models/core/control.model';
import { REFRESH_TIMEOUT_2_SEC } from '../../../constants/data.constant';

let timerId = null;

export class ControlContainerCore extends Component {
    constructor(...args) {
        var _temp;

        return _temp = super(...args), this._refreshLoad = (pause = REFRESH_TIMEOUT_2_SEC) => {
            clearTimeout(timerId);
            timerId = setTimeout(this._loadFull, pause);
        }, this._loadFull = () => {
            this._refreshLoad();
            if (!this.props.controlsData.isLoading && this.props.controlsData.items.length) {
                this.props.handleGetBatchData([!this.props.controlsData.power.isLoading && {
                    apiFunc: controlModel.apiGetDevicesPowerSum,
                    processFunc: controlModel.processGetDevicesPowerSum,
                    params: { items: this.props.controlsData.items },
                    errorFunc: controlModel.requestGetDevicesPowerSum
                }, {
                    apiFunc: controlModel.apiGetDevicesPowerLimits,
                    processFunc: controlModel.processGetDevicesPowerLimits
                    // errorFunc: controlModel.requestGetDevicesPowerSum
                }, !this.props.controlsData.power.status.isLoading && {
                    apiFunc: controlModel.apiGetDevicesStatus,
                    processFunc: controlModel.processGetDevicesStatus,
                    params: {
                        items: this.props.controlsData.items,
                        isOldData: this.props.controlsData.oldData.isOldData
                    },
                    errorFunc: controlModel.requestGetDevicesStatus
                }]);
            }
        }, _temp;
    }

    componentDidMount() {
        setTimeout(() => {
            this._loadFull(false);
        }, 0);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.controlsData.items.length && this.props.controlsData.items.length) {
            this._loadFull();
        }
    }

    componentWillUnmount() {
        clearTimeout(timerId);
        timerId = null;
    }

    render() {
        return null;
    }
}

export const mapStateToPropsCore = (state, props) => {
    return {
        controlModel,
        costState: state.costReducer,
        controlsData: state.control[controlModel.MODEL_NAME],
        settings: state.settings[settingsModel.MODEL_NAME]
    };
};

export const mapDispatchToPropsCore = apiGetBatchData => dispatch => {
    return {
        handleGetBatchData: bindActionCreators(apiGetBatchData, dispatch)
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/containers/pages/core/Control.container.js